import { useEffect } from "react";
import {
  EmailsIcon,
  HistoryIcon,
  commentIcon,
  tableEditIcon,
} from "../../assets/images";
import {
  COLOR_CODES,
  STAGE_COLOR_CODES,
  FONT_COL_CODES,
} from "../../constant/colors";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { CircularAvatar } from "../commons";
import {
  formateDateAndTime,
  formateDateTime,
} from "../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { SendEmailPayload } from "../../commonTypes/clientDirectoryTypes";

type AppProps = {
  tableHeader: TableHeadersType[] | [];
  leadDirectoryList: [] | any[];
  handleEditLeadModule: (id: number) => void;
  isEditClientLeadDetailsPresent: boolean;
  handleToggleLeadCommentsModal?: () => void;
  handleSetLeadData?: (data: any) => void;
  handleHistoryLeadModule: (data: any) => void;
  handleToggleSentEmailToLead: () => void;
  handleSentEmailToLead: (data: SendEmailPayload) => void;
  isEmailLeadDetailsPresent: boolean;
  offset: number;
};

const LeadModuleActionTableData = ({
  tableHeader,
  leadDirectoryList,
  handleEditLeadModule,
  isEditClientLeadDetailsPresent,
  handleToggleLeadCommentsModal,
  handleSetLeadData,
  handleHistoryLeadModule,
  handleToggleSentEmailToLead,
  handleSentEmailToLead,
  isEmailLeadDetailsPresent,
  offset,
}: AppProps) => {
  //========== User Management==========//
  const [isAddLeadCommentsPresent, setIsAddLeadCommentsPresent] =
    useMenuCheck();

  //====================//

  useEffect(() => {
    setIsAddLeadCommentsPresent("Add Lead Module Comments", "menu");
  }, []);

  const backColor = (name: string) => {
    const lowerCaseName = name.toLowerCase();

    let backgroundColor;
    let fontColor;

    if (lowerCaseName.startsWith("1")) {
      backgroundColor = STAGE_COLOR_CODES[0];
      fontColor = FONT_COL_CODES[0];
    } else if (
      lowerCaseName.startsWith("2a") ||
      lowerCaseName.startsWith("2b") ||
      lowerCaseName.startsWith("2bii") ||
      lowerCaseName.startsWith("2biii") ||
      lowerCaseName.startsWith("2biv") ||
      lowerCaseName.startsWith("2bv")
    ) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (
      lowerCaseName.startsWith("2c") ||
      lowerCaseName.startsWith("2d")
    ) {
      backgroundColor = STAGE_COLOR_CODES[2];
      fontColor = FONT_COL_CODES[2];
    } else if (
      lowerCaseName.startsWith("3a") ||
      lowerCaseName.startsWith("3b")
    ) {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    } else if (
      lowerCaseName.startsWith("4a") ||
      lowerCaseName.startsWith("4b") ||
      lowerCaseName.startsWith("5")
    ) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (
      lowerCaseName.startsWith("6a") ||
      lowerCaseName.startsWith("6b") ||
      lowerCaseName.startsWith("6c") ||
      lowerCaseName.startsWith("6d") ||
      lowerCaseName.startsWith("6e")
    ) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };
  const styleColor = (name: string) => {
    const { backgroundColor, fontColor } = backColor(name);

    return {
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {
      // color:"white"
    };
  };

  const calMAxLen = () => {
    let maxLength = 0;
    let height = 0;
    leadDirectoryList?.map((data) => {
      maxLength =
        maxLength > data?.company_name?.length
          ? maxLength
          : data?.company_name?.length;
    });
    if (maxLength > 0 && maxLength <= 30) {
      height = 60;
    } else if (maxLength > 30 && maxLength < 100) {
      height = 90;
    } else {
      height = 120;
    }
    return 90;
  };

  return (
    <>
      {leadDirectoryList?.length > 0 &&
        leadDirectoryList?.map((LeadModuleListData: any) => {
          return (
            <tr
              className="text-left"
              style={{
                lineHeight: "0.23",
                whiteSpace: "nowrap",
                height: `${calMAxLen()}px`,
              }}
            >
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "comment_details") {
                    return (
                      <td className="text-left">
                        {LeadModuleListData?.last_comment?.comment?.length >
                        15 ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {LeadModuleListData?.last_comment?.comment}
                              </Tooltip>
                            }
                          >
                            <p
                              style={{
                                marginBottom: "0px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {LeadModuleListData?.last_comment?.comment?.slice(
                                0,
                                15
                              )}
                              ...
                            </p>
                          </OverlayTrigger>
                        ) : (
                          <p
                            style={{
                              marginBottom: "0px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {LeadModuleListData?.last_comment?.comment
                              ?.length ? (
                              LeadModuleListData?.last_comment?.comment?.slice(
                                0,
                                15
                              )
                            ) : (
                              <div style={{ paddingTop: "14px" }}>--/--</div>
                            )}
                          </p>
                        )}
                        <p
                          className="due-date-text"
                          style={{
                            marginBottom: LeadModuleListData?.last_comment
                              ?.commented_at
                              ? "5px"
                              : "0px",
                            marginTop: LeadModuleListData?.last_comment
                              ?.commented_at
                              ? "20px"
                              : "0px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {LeadModuleListData?.last_comment?.commented_at
                            ? formateDateTime(
                                LeadModuleListData?.last_comment?.commented_at
                              )
                            : ""}
                        </p>
                      </td>
                    );
                  } else if (header?.value == "action") {
                    return (
                      <>
                        <td
                          style={{
                            width: "50px",
                            textAlign: "start",
                            paddingRight: "20px",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="history-tooltip">
                                    View History
                                  </Tooltip>
                                }
                              >
                                <span className="d-inline-block pointer">
                                  <div
                                    style={{
                                      color: "#d43",
                                      fontSize: 20,
                                      width: "30px",
                                    }}
                                    onClick={() =>
                                      handleHistoryLeadModule(
                                        LeadModuleListData
                                      )
                                    }
                                  >
                                    <img src={HistoryIcon} alt="" />
                                  </div>
                                </span>
                              </OverlayTrigger>
                            </div>
                            {isEditClientLeadDetailsPresent && (
                              <div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="edit-tooltip">Edit</Tooltip>
                                  }
                                >
                                  <span className="d-inline-block pointer">
                                    <div
                                      style={{
                                        color: "#d43",
                                        fontSize: 20,
                                        width: "30px",
                                      }}
                                      onClick={() =>
                                        handleEditLeadModule(
                                          LeadModuleListData?.client_code
                                        )
                                      }
                                    >
                                      <img src={tableEditIcon} alt="" />
                                    </div>
                                  </span>
                                </OverlayTrigger>
                              </div>
                            )}
                            {isAddLeadCommentsPresent && (
                              <div style={{ position: "relative" }}>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="comment-tooltip">
                                      Add Comment or Link
                                    </Tooltip>
                                  }
                                >
                                  <span className="d-inline-block pointer">
                                    <div
                                      onClick={() => {
                                        handleToggleLeadCommentsModal?.();
                                        handleSetLeadData?.(LeadModuleListData);
                                      }}
                                    >
                                      {LeadModuleListData?.comment_count ? (
                                        <span
                                          className={
                                            LeadModuleListData?.comment_count >=
                                            100
                                              ? `jobs-link-count-more-character`
                                              : `jobs-link-count`
                                          }
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          {LeadModuleListData?.comment_count}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                      <img
                                        src={commentIcon}
                                        alt="comment-icon"
                                      ></img>
                                    </div>
                                  </span>
                                </OverlayTrigger>
                              </div>
                            )}
                            {isEmailLeadDetailsPresent && (
                              <div>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="send-email-tooltip">
                                      Send Email
                                    </Tooltip>
                                  }
                                >
                                  <span className="d-inline-block pointer ml-2">
                                    <div
                                      style={{
                                        color: "#d43",
                                        fontSize: 20,
                                        width: "30px",
                                      }}
                                      onClick={() => {
                                        handleToggleSentEmailToLead();
                                        handleSentEmailToLead({
                                          to_email:
                                            LeadModuleListData?.client_email,
                                          client_code:
                                            LeadModuleListData?.client_code,
                                        });
                                      }}
                                    >
                                      <img src={EmailsIcon} alt="" />
                                    </div>
                                  </span>
                                </OverlayTrigger>
                              </div>
                            )}
                          </div>
                        </td>
                      </>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default LeadModuleActionTableData;
